import Chip from "@mui/material/Chip";
import Typography, { TypographyProps } from "@mui/material/Typography";
import styled from "styled-components";

export const SummaryContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SummaryColumn = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const DetailsTitle = styled.span`
  color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.primary.main
      : theme.palette.text.secondary};
  font-weight: 500;
  font-size: 0.9rem;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const DetailsInfo = styled.span`
  margin-right: ${({ theme }) => theme.spacing(2)};
  font-size: 0.9rem;
`;

export const DetailsInfoColored = styled(DetailsInfo)`
  color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.text.primary
      : theme.palette.primary.main};
  font-weight: 450;
  font-size: 0.9rem;
`;

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(0.5)};
`;

export const Title = styled(Typography)<
  TypographyProps<"h2", { component: "h2" }>
>`
  margin-right: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const SummaryKeyValue = styled(Typography)`
  margin-right: ${({ theme }) => theme.spacing(2)};
`;

export const Tag = styled(Chip)`
  margin-right: ${({ theme }) => theme.spacing(2)};
  /* font-weight: 450; */
  background: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.grey[900]
      : theme.palette.grey[100]};
`;

export const NoDataText = styled(Typography)`
  text-align: center;
  line-height: ${({ theme }) => theme.spacing(7)};
`;

export const LoaderContainer = styled.div`
  height: ${({ theme }) => theme.spacing(20)};
`;
